export const StaticText = {
    brand_name: 'Box8',
    startYear: '2013',
    app_offer: {
        messgeText: 'Flat ₹200 OFF on first app order',
        codeText: 'Code: MEAL200 | Download Now!',
        discount: 'Flat ₹200 OFF',
        discount_condition: 'on first app order',
        discount_code: 'MEAL200'
    },
    noOrderText: {
        tagline: 'Awaiting your orders! ',
        offerText: 'Avail ₹200 OFF on 1st order. ',
        offerCode: 'Code: MEAL200'
    },
    brand: {
        heading: 'Explore Our Brands',
        sub_heading: 'Whether you need a delicious Desi Meal or want your daily groceries delivered home, we’ve got you covered!'
    },
    pass_name: 'EatClub',
    share: {
        link_text: 'Refer & Earn',
        hash_tag: '#Refer&Earn',
        offer: 'Free Meals'
    },
    push_notification: {
        icon: 'https://assets.box8.co.in/favicon/B8-favicon.png',
        heading: 'Now open & ready to serve you!🥘',
        sub_heading: 'Tap to complete your order. Irresistible Desi Meals! Dal Makhni, Kadhai Paneer, Butter Chicken & more.',
    },
    smartBanner: {
        download_info: '(65,324) | 1Mn+ Downloads'
    },
    preloadImage: 'https://assets.box8.co.in/missing/box8.png'
};
